export default {
  // 11位电话号码
  phone: /^[1][0-9]{10}$/,
  // 中英文，允许空格
  name: /^[\u4e00-\u9fa5_a-zA-Z0-9\s]+$/,
};



// WEBPACK FOOTER //
// ./src/shared/regExp/index.js